export default __webpack_public_path__ + "static/media/lock_icon_q_mark.87108300.svg";